import { createSelector } from "@reduxjs/toolkit";

export const selectFrameAreasToRender = createSelector(
  (state) => state.Uterum,
  (Uterum) => {
    const { FrameAreas } = Uterum;
    const hiddenFrames = [
      "ONSIDE_TOP_RIGHT_2",
      "ONSIDE_TOP_RIGHT_3",
      "ONSIDE_TOP_RIGHT_4",
      "ONSIDE_TOP_RIGHT_5",
      "ONSIDE_TOP_LEFT_2",
      "ONSIDE_TOP_LEFT_3",
      "ONSIDE_TOP_LEFT_4",
      "ONSIDE_TOP_LEFT_5",
    ];

    if (!FrameAreas) {
      return null;
    }

    const filteredFrameAreas =
      Uterum.FrameType === "FIRAXL"
        ? FrameAreas.filter(
            (frameArea) =>
              !hiddenFrames.includes(frameArea.AreaCn) && frameArea.Render
          )
        : FrameAreas.filter((frameArea) => frameArea.Render);

    return filteredFrameAreas;
  }
);
